import React, { Component } from "react";
import { getContent } from "./Content";
import { connect } from "react-redux";
import { mapStateToProps } from "./ContentHelper";

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || "Component";
}

function resolveContent(props, componentContent) {
  let contentifiedProps = {};
  let items = componentContent ? componentContent : props;

  Object.keys(items).forEach((key) => {
    if (key !== "reduxProps" && key !== "params") {
      if (isContentifiable(items[key])) {
        contentifiedProps[key] = getContent(
          props.reduxProps,
          items[key],
          props.params
        );
      } else {
        contentifiedProps[key] = items[key];
      }
    }
  });
  return contentifiedProps;
}

export function isContentifiable(value) {
  return (
    typeof value === "object" &&
    !!value &&
    (value.hasOwnProperty("Any") ||
      value.hasOwnProperty("HOL") ||
      value.hasOwnProperty("MOL") ||
      value.hasOwnProperty("Lapsed") ||
      value.hasOwnProperty("Format2") ||
      value.hasOwnProperty("SME") ||
      value.hasOwnProperty("LargeCorporate") ||
      value.hasOwnProperty("Saga") ||
      value.hasOwnProperty("International") ||
      value.hasOwnProperty("Format2AndNonHealthSelect") ||
      value.hasOwnProperty("Claims") ||
      value.hasOwnProperty("FastTrack") ||
      value.hasOwnProperty("HOLMOL") ||
      value.hasOwnProperty("SMEModular"))
  );
}

export const mapContentifyStateToProps = (state) => {
  return {
    reduxProps: mapStateToProps(state)
  };
};

export default function (WrappedComponent) {
  class Contentified extends Component {
    render() {
      let contentifiedProps = resolveContent(this.props);
      if (WrappedComponent.content) {
        contentifiedProps.content = resolveContent(
          this.props,
          WrappedComponent.content
        );
      }
      return <WrappedComponent {...contentifiedProps} />;
    }
  }
  Contentified.displayName = `Contentified<${getDisplayName(
    WrappedComponent
  )}>`;
  return connect(mapContentifyStateToProps)(Contentified);
}
